import React from 'react'

const Specify=()=>{
    return (
      <div className="specification">
        <div className="child1">
        <i className="fa-solid fa-truck-fast"></i>
          <span className="child1cnt">
           Free Delivery<br />
           <span>Order From All Items</span>
          </span>
        </div>
        <div className="child2">
            <i class="fa-solid fa-indian-rupee-sign"></i>
            <span className="child2cnt">
             Return & Refund<br />
            <span>Money Back Guarantee</span>
            </span>
            
            </div>
            <div className="child3">
            <i class="fa-solid fa-tags"></i>
            <span className="child3cnt">
             Member Discount<br />
            <span>On Order Over $99</span>
            </span>
            
            </div>
            <div className="child4">
            <i class="fa-solid fa-headset"></i>
            <span className="child4cnt">
             Support 24/7<br />
            <span>Contact us 24 hours a day</span>
            </span>
            
            </div>
        </div>
    )
  }

  export default Specify